import { render } from "./bbIndustryManage.vue?vue&type=template&id=4fa4b4e2"
import script from "./bbIndustryManage.vue?vue&type=script&lang=js"
export * from "./bbIndustryManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__